import React, { useEffect } from 'react';
import CommonLayout from 'components/CommonLayout';
import messages from 'containers/MyAccountPage/messages';
import { get, isEmpty } from 'lodash';
import { AssuranceIcon } from 'images';

import { StyledContainer } from 'containers/MyAccountPage/styles';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'helpers/intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getProfileSettingsInfo } from 'store/user/actions';
import {
  profileSettingsInfo,
  getIsUpdateProfileSettingsLoadingSelector,
} from 'store/user/selectors';
import { ProfileSettingsInfoType } from 'store/user/types';
import Form from 'containers/MyAccountPage/Form';
import { updateProfileSettingsInfo } from 'store/user/actions';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export interface MyAccountPageType {
  intl: IntlShape;
  getProfileSettingsInfo: Function;
  profileSettingsInfo: ProfileSettingsInfoType;
  updateProfileSettingsInfo: Function;
  isUpdateProfileSettingsLoading: boolean;
}
const MyAccountPage = (props: MyAccountPageType) => {
  useEffect(() => {
    props.getProfileSettingsInfo();
    // eslint-disable-next-line
  }, []);

  const {
    profileSettingsInfo,
    updateProfileSettingsInfo,
    isUpdateProfileSettingsLoading,
  } = props;

  return (
    <GaLoadHOC
      label="Paramètres du compte"
      category={EVENT_CATEGORIES.SETTINGS}
    >
      <CommonLayout
        title={messages.title}
        icon={
          <img
            height="30px"
            width="30px"
            src={get(AssuranceIcon, 'profilSetting')}
            alt="profile-setting-icon"
          />
        }
        subTitle={translate({ ...messages.subTitle }, props)}
        content={
          <StyledContainer maxWidth="sm">
            {!isEmpty(profileSettingsInfo.bday) && (
              <Form
                profileSettingsInfo={profileSettingsInfo}
                updateProfileSettingsInfo={updateProfileSettingsInfo}
                isLoading={isUpdateProfileSettingsLoading}
              />
            )}
          </StyledContainer>
        }
      />
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    profileSettingsInfo: ProfileSettingsInfoType;
    isUpdateProfileSettingsLoading: boolean;
  }
>({
  profileSettingsInfo,
  isUpdateProfileSettingsLoading: getIsUpdateProfileSettingsLoadingSelector,
});

const mapDispatchToProps = {
  getProfileSettingsInfo,
  updateProfileSettingsInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyAccountPage));

export const MyAccountTestPage = injectIntl(MyAccountPage);
